import {useEffect, useState} from 'react';

const useUpdateByTime = ({time}: {time: number}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(count + 1);
    }, time);

    return () => clearInterval(interval);
  }, [count, time]);

  return count;
};

export default useUpdateByTime;
